<template>
  <div class='overflow-auto'>
    <table class="table">
      <thead>
        <tr>
          <th v-if='displayWeight' class="p-2">{{ $t("js.backend.ballot_summary.count_header") }}</th>
          <th class="p-2">{{ $t("js.backend.ballot_summary.voter_counts.total_eligibles") }}</th>
          <th class="p-2">{{ $t("js.backend.ballot_summary.voter_counts.active_eligibles_or_voted") }}</th>
          <th class="p-2">{{ $t("js.backend.ballot_summary.voter_counts.voted") }}</th>
          <th class="p-2">{{ $t("js.backend.ballot_summary.participation") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th v-if='displayWeight' class="p-2">{{ $t("js.backend.ballot_summary.voter_counts.by_individual") }}</th>
          <td class="p-2">{{ turnout.eligible }}</td>
          <td class="p-2">{{ turnout.present }}</td>
          <td class="p-2">{{ turnout.voted }}</td>
          <td class="p-2">{{ twoDecimalPercentage(turnout.voted, turnout.eligible ) }}</td>

        </tr>
        <tr v-if='displayWeight'>
          <th class="p-2">{{ $t("js.backend.ballot_summary.voter_counts.by_weight") }}</th>
          <td class="p-2">{{ turnout.eligibleWeight }}</td>
          <td class="p-2">{{ turnout.presentWeight }}</td>
          <td class="p-2">{{ turnout.votedWeight }}</td>
          <td class="p-2">{{ twoDecimalPercentage(turnout.votedWeight, turnout.eligibleWeight) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType, Turnout } from "@/types";

export default defineComponent({
  name: "TurnoutTable",
  props: {
    turnout: {
      type: Object as PropType<Turnout>,
      required: true,
    },
    hideWeight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    weightDiff() {
      return this.turnout.eligible != this.turnout.eligibleWeight
    },
    displayWeight(){
      return !this.hideWeight && this.weightDiff
    }
  },
  methods: {
    twoDecimalPercentage(divisor: number, dividend: number) {
      let fraction = divisor / dividend
      let config: Intl.NumberFormatOptions = {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }

      let formatter = new Intl.NumberFormat(this.$i18n.locale, config);
      return formatter.format(fraction);
    }
  }
});
</script>

